import RegenerateEmail from "@/views/public/RegenerateEmail.vue";
import VerifyEmail from "@/views/public/VerifyEmail.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/nouvel-email/:token?/:emailFrom/:emailTo",
        name: RouteEnum.EMAIL_REGENERATE,
        component: RegenerateEmail
    },
    {
        path: "/verify-email",
        name: RouteEnum.EMAIL_CHECK,
        component: VerifyEmail
    },
]
